// extracted by mini-css-extract-plugin
export default {"facility":"facility_facility__TIWcY"};